export class CatModel {
    public id: number;
    public description: string;
    public createdAt: string;
    public updatedAt: string;
    public value: string;
    public image: string;

    constructor(res: any) {
        this.id = res.id;
        this.description = res.description || '';
        this.createdAt = res.createdAt || '';
        this.updatedAt = res.updatedAt || '';
        this.value = res.value || '';
        this.image = res.image || '';
    }
}

export class PdfItemModel {
    public id: number;
    public description: string;
    public createdAt: string;
    public updatedAt: string;
    public value: string;

    constructor(res: any) {
        this.id = res.id;
        this.description = res.description || '';
        this.createdAt = res.createdAt || '';
        this.updatedAt = res.updatedAt || '';
        this.value = res.value || '';
    }
}

export class SliderItemModel {
    public content: string;
    public createdAt: string;
    public description: string;
    public id: number;
    public image: string;
    public position: number;
    public subtitle: string;
    public title: string;
    public typeitem: string;
    public updatedAt: string;

    constructor(res: any) {
        this.content = res.content || '';
        this.createdAt = res.createdAt || '';
        this.description = res.description || '';
        this.id = res.id;
        this.image = res.image || null;
        this.position = +res.position || 0;
        this.subtitle = res.subtitle || '';
        this.title = res.title || '';
        this.typeitem = res.typeitem || '';
        this.updatedAt = res.updatedAt || '';
    }
}

export class SlideModel {
    public createdAt: string;
    public id: number;
    public name: string;
    public slideritems: SliderItemModel[];
    public typeslider: string;
    public updatedAt: string;

    constructor(res: any) {
        this.createdAt = res.createdAt || '';
        this.id = res.id;
        this.name = res.name || '';
        this.slideritems = res.slideritems || [];
        this.typeslider = res.typeslider || '';
        this.updatedAt = res.updatedAt || '';
    }
}